if (!customElements.get('aurviq-navigation')) {
  customElements.define('aurviq-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-menu-open]');
      trigger.addEventListener('click', () => { dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); }, { signal });
      this.querySelector('[data-menu-close]').addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('close', () => trigger.setAttribute('aria-expanded', 'false'), { signal });
      dialog.addEventListener('click', event => {
        if (event.target.closest('a')) dialog.close();
        if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX > r.right || event.clientX < r.left) dialog.close(); }
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('aurviq-product')) {
  customElements.define('aurviq-product', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      const main = this.querySelector('.aq-gallery-image');
      const thumbs = [...this.querySelectorAll('[data-gallery-src]')];
      const showImage = (src, alt) => { main.removeAttribute('srcset'); main.src = src; if (alt) main.alt = alt; };
      thumbs.forEach(thumb => thumb.addEventListener('click', () => {
        showImage(thumb.dataset.gallerySrc, thumb.querySelector('img')?.alt);
        thumbs.forEach(t => t.setAttribute('aria-pressed', String(t === thumb)));
      }, { signal }));
      const lightbox = this.querySelector('.aq-lightbox');
      this.querySelector('[data-zoom]').addEventListener('click', () => { lightbox.querySelector('img').src = main.currentSrc || main.src; lightbox.querySelector('img').alt = main.alt; lightbox.showModal(); }, { signal });
      this.querySelector('[data-zoom-close]').addEventListener('click', () => lightbox.close(), { signal });
      lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); }, { signal });
      const select = this.querySelector('[data-variant-select]');
      const quantity = this.querySelector('[name="quantity"]');
      const quantityButtons = [...this.querySelectorAll('[data-quantity]')];
      const syncQuantity = () => {
        if (!quantity) return;
        quantityButtons.forEach(button => {
          const value = quantity.valueAsNumber;
          button.disabled = button.dataset.quantity === 'minus'
            ? value <= Number(quantity.min || 1)
            : Boolean(quantity.max) && value >= Number(quantity.max);
        });
      };
      quantityButtons.forEach(button => button.addEventListener('click', () => {
        if (!Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
        if (button.dataset.quantity === 'plus') quantity.stepUp(); else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal }));
      quantity?.addEventListener('change', syncQuantity, { signal });
      quantity?.addEventListener('input', syncQuantity, { signal });
      quantity?.addEventListener('invalid', () => quantity.scrollIntoView({ block: 'center' }), { signal });
      syncQuantity();
      const chips = [...this.querySelectorAll('[data-variant-id]')];
      if (select && chips.length > 1 && chips.length <= 8) {
        this.querySelector('.aq-variant-chips').hidden = false;
        select.classList.add('aq-visually-hidden');
        select.tabIndex = -1;
        chips.forEach(chip => chip.addEventListener('click', () => {
          select.value = chip.dataset.variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal }));
      }
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.querySelector('[data-sticky-price]').textContent = option.dataset.price;
        const compare = this.querySelector('s[data-compare]');
        if (compare) {
          compare.hidden = !option.dataset.compare;
          compare.querySelector('[data-compare-value]').textContent = option.dataset.compare || '';
        }
        if (quantity) {
          quantity.min = option.dataset.min || '1';
          quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
          syncQuantity();
        }
        const available = option.dataset.available === 'true';
        this.querySelector('button[name="add"]').disabled = !available;
        this.querySelector('[data-add-text]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        chips.forEach(chip => chip.setAttribute('aria-pressed', String(chip.dataset.variantId === select.value)));
        const stickyButton = this.querySelector('[data-sticky-add]');
        if (stickyButton) {
          stickyButton.disabled = !available;
          stickyButton.querySelector('[data-sticky-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        }
        if (option.dataset.image) { showImage(option.dataset.image, option.dataset.alt); thumbs.forEach(t => t.setAttribute('aria-pressed', String(t.dataset.gallerySrc === option.dataset.image))); }
      }, { signal });
      this.observer?.disconnect();
      const sticky = this.querySelector('.aq-sticky-buy');
      this.observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 });
      this.observer.observe(this.querySelector('.aq-buy-button'));
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
function revealContactResult() {
  const contact = document.querySelector('.aq-contact-details');
  if (contact && (['#AurviqContact', '#AurviqContactDetails'].includes(location.hash) || contact.querySelector('[role="status"], .errors'))) contact.open = true;
}
document.addEventListener('DOMContentLoaded', revealContactResult);
window.addEventListener('hashchange', revealContactResult);
